import { createVideoContentVideos } from '../store/actions/videoContentVideosActions';

export default {
  getURL: 'liveIngestserver',
  canOpen: false,
  isSelectable: true,
  // sessionParams: ['appId', 'areaId'],
  fields: [
    {
      width: '25rem',
      attributeName: 'hostName',
      helpText: 'Host name.',
      label: 'Host name',
      canFilter: true,
    },
    {
      width: '35rem',
      attributeName: 'ip',
      helpText: 'get ip.',
      label: 'IP',
      canFilter: true,
    },
    {
      width: '35rem',
      attributeName: 'last_connection',
      helpText: 'Last time the ingest connected to the XMS.',
      label: 'Last Conn',
    },
    {
      width: '35rem',
      attributeName: 'from',
      helpText: 'Who created the ingest server.',
      label: 'From',
      canFilter: true,
    },
    {
      width: '35rem',
      attributeName: 'graphicsInfo',
      helpText: 'Info about graphic boards.',
      label: 'Graphics Info',
      canFilter: true,
    },
  ],
};
